import { render } from "./IdentityDocument.vue?vue&type=template&id=3542055e"
import script from "./IdentityDocument.vue?vue&type=script&lang=js"
export * from "./IdentityDocument.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__